import i18n from 'i18next';
import transFi from './translations/fi';
import transEn from './translations/en';
import transSv from './translations/sv';
import { formatValue } from './i18nFormat';

const savedLanguage = localStorage.getItem('selectedLanguage') || 'fi';

i18n.init({
  resources: {
    en: transEn,
    fi: transFi,
    sv: transSv,
  },
  fallbackLng: 'en',
  debug: false,
  lng: savedLanguage,

  ns: ['default', 'common', 'Footer', 'HomeView'],
  defaultNS: 'default',
  keySeparator: false,

  interpolation: {
    escapeValue: false,
    formatSeparator: ',',
    // A translation writes {{time, datetime}} and gets a date in the language it is written
    // in. Inert for every other placeholder: without a format spec the value is returned
    // unchanged, so the product's existing interpolations are untouched.
    format: formatValue,
  },

  react: {
    wait: true,
  },
});

export default i18n;
